import type { SetupStepId } from '@/types';

/**
 * A page finishing its setup step on purpose (saved the company details) tells
 * the guide directly. The guide also advances when a step's derived state flips
 * to done, but some steps start out done (a new team's company name comes from
 * sign-up), so a flip alone would never move the person on.
 */
const COMPLETE = 'billable:setup-step-complete';

export function completeSetupStep(id: SetupStepId) {
  window.dispatchEvent(new CustomEvent<SetupStepId>(COMPLETE, { detail: id }));
}

export function onSetupStepComplete(fn: (id: SetupStepId) => void) {
  const handler = (e: Event) => fn((e as CustomEvent<SetupStepId>).detail);
  window.addEventListener(COMPLETE, handler);
  return () => window.removeEventListener(COMPLETE, handler);
}

/**
 * What the guide's button does on the step's own page. A page registers one
 * while mounted (Settings saves and completes the firm step); without one the
 * button scrolls to the step's target.
 */
const actions = new Map<SetupStepId, () => void>();

export function registerStepAction(id: SetupStepId, fn: () => void) {
  actions.set(id, fn);
  return () => {
    if (actions.get(id) === fn) actions.delete(id);
  };
}

export function runStepAction(id: SetupStepId): boolean {
  const fn = actions.get(id);
  if (!fn) return false;
  fn();
  return true;
}
